import { createStyles } from '@mui/styles';
import { APTheme } from "../../../core/TenantProvider/tenants";

export default (theme: APTheme) =>
  createStyles({
    "@keyframes onloadup": {
      "0%": {
        opacity: 0,
        transform: "translateY(65px)"
      },
      "100%": {
        opacity: 1,
        transform: "translateY(0)"
      }
    },
    resetPasswordContainer: {
      display: "flex",
      justifyContent: "center",
      animationName: `$onloadup`,
      animationDuration: '0.3s',
      animationFillMode: 'both',
      animationTimingFunction: 'cubic-bezier(0.680, -0.550, 0.265, 1.550) both',
    },
    resetPasswordContent: {
      width: "100%",
      padding: '9em 0 4em 0',
      [theme.breakpoints.down('lg')]: {
        padding: '6em 0 4em 0',
      },
    },
    resetPasswordInput: {
      width: "100%",
      '&:last-of-type': {
        marginBottom: 0,
      }
    },
    resetPasswordEmailInput: {
      width: "100%",
      [theme.breakpoints.down('md')]: {
        marginBottom: 20,
      },
      '&:last-of-type': {
        marginBottom: 0,
      }
    },
    resetPasswordIntro: {
      maxWidth: 460,
      color: "#4A4A4A",
      margin: '0 auto 50px',
      padding: '0 16px',
      '& h4': {
        fontSize: '2.6rem',
        letterSpacing: '-1px',
        marginBottom: 20,
        [theme.breakpoints.down('sm')]: {
          fontSize: '2.0rem',
        },
      }
    },
    resetPasswordIntroSent: {
      maxWidth: 540,
      marginBottom: '5rem'
    },
    resetPasswordIntroHeader: {
      marginBottom: 30,
      textAlign: "center",
    },
    resetPasswordIntroText: {
      display: "block",
      textAlign: "center",
    },
    resetPasswordActions: {
      display: "flex",
      justifyContent: "center",
      padding: '0 16px',
      maxWidth: 460,
      margin: 'auto',
      [theme.breakpoints.down('md')]: {
        flexFlow: 'wrap-reverse',
      },
    },
    createPasswordActions: {
      display: "flex",
      justifyContent: "center",
      maxWidth: 200,
      margin: '0 auto 0',
      padding: '0 16px',
      [theme.breakpoints.down('md')]: {
        flexFlow: 'wrap-reverse',
        maxWidth: 460,
      },
      "& button": {
        margin: 0,
      },
    },
    resetPasswordLinkSection: {
      display: "flex",
      justifyContent: "center",
      marginTop: 25,
      fontSize: "16px",
      color: "#4A4A4A",
      "& a": {
        display: "inline-block",
        color: "#2D91E9",
        textDecoration: "none",
        marginLeft: 4,
      },
    },
    resetPasswordButtons: {
      margin: "0 15px",
      width: '100%',
      padding: "5px 0",
      [theme.breakpoints.down('md')]: {
        margin: "0 0 15px 0",
      },
    },
    loginButton: {
      margin: "25px 15px 0 15px",
      padding: "5px 0",
      color: "#2D91E9",
      border: "1px solid #E8E8E8",
      background: "#FFF",
      maxWidth: 200,
      [theme.breakpoints.down('md')]: {
        width: "100%",
      },
      "&:hover": {
        background: "#FFF",
        border: "1px solid #2D91E9",
      },
    },
    inputsSurround: {
      //width: "100%",
      maxWidth: 460,
      margin: '0 auto 30px',
      padding: '0 16px',
      position: 'relative'
    },
    resendPasswordLoader: {
      marginTop: '40px'
    },
    errorSurround: {
      margin: "0 25px",
      color: "#FF5F5F",
      fontSize: "12px",
      lineHeight: "18px",
      height: "auto",
    },
    passwordEyeIcon: {
      right: 16,
      margin: 0,
      position: "absolute",
      top: 6,
      height: 46,
      width: 46,
      zIndex: 1
    },
    passwordAdornment: {
      height: 80,
      maxHeight: "none",
    },
    spinnerHide: {
      display: "none",
    },
    spinnerShow: {
      display: "show",
    },
    resetPasswordButtonWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  });
